module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-3.7020b30f.png";